<template>
  <main>
    <div class="empty" v-if="data.length == 0"> <span>{{$t('historyPage.noHistory')}}</span></div>
    <div class="account-list" v-if="data.length>0">
      <div  v-for="(item, index) in data"  :key = "index"  class="account-item">
        <div class="account-id">{{item["create_at"]}}</div>
        <div class="account-id">{{item["amount"].toFixed(2)}}</div>
        <div class="account-id">{{type[item["type"]]}}</div>
        <div class="account-status">{{status[item["status"]]}}</div>
      </div>
    </div>
  </main>
  <div v-if="loading" class="loading-overlay" >
    <div class="loading-spinner"></div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";
import {getCookie} from "@/utils/cookie";

export default {
  name: 'HistoryPage',
  data() {
    return {
      amount:0,
      showerror:false,
      errorMsg:"",
      loading:false,
      data:[],
      status:{
        0:this.$t('historyPage.finish'),
        1:this.$t('historyPage.pendding'),
        2:this.$t('historyPage.fail'),
      },
      type:{
        1:this.$t('historyPage.buy'),
        2:this.$t('historyPage.sell'),
        3:this.$t('historyPage.recharge'),
        4:this.$t('historyPage.withdrawal'),
        5:this.$t('historyPage.award'),
        6:this.$t('historyPage.other'),
        7:this.$t('historyPage.fee'),
      }
    }
  },
  created() {
    this.fetchHistory()
  },
  methods: {
    closeError(){
      this.showerror = false
    },
    openError(msg){
      this.errorMsg = msg
      this.showerror = true
    },
    async fetchHistory(){
      this.loading = true
      axios.get(config.apiHost+'/history', {
        headers: {
          'Content-Type': 'application/json',
          'loginsign':getCookie("signature"),
          'Loginmsg':getCookie("login_msg"),
        }
      }).then(response => {
        // 处理响应数据
        var data = response.data
        if(data.login){
          if(data.ok){
            this.data = data.data;
          }else{
            this.$store.commit('setShowWalletMsg',data.msg);
          }
        }else{
          this.$store.commit('setLoginOut')
          this.$router.push({ name: "MyPage", params: {} });
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
        // 处理错误
        console.error(error);
      });
    }
  }
};
</script>

<style scoped>
.empty {
  text-align: center;
  color: #9aa3b5;
  padding: 48px 0;
}
.account-list {
  background: rgba(16, 22, 35, 0.9);
  border-radius: 16px;
  overflow: hidden;
  padding-bottom: 5rem;
  border: 1px solid rgba(212, 175, 55, 0.14);
}

.account-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  gap: 6px;
}

.account-item:last-child {
  border-bottom: none;
}

.account-id {
  font-size: 0.78rem;
  margin: 0;
}

.account-status {
  font-size: 0.78rem;
  color: #f0d78c;
}

</style>
